import { Spinner } from "@hybrid-iptv/ui";
import { useCatalogRebuild } from "../library/catalogRebuildStore.js";

/**
 * "Optimizing your app" while the APK rebuilds its stored catalog after a new
 * download (once a day at most). It sits out of the way, takes no focus, and
 * disappears on its own when the rebuild finishes — nothing is blocked while it
 * shows, because the screens answer from the previous copy.
 *
 * `compact`: one line in the top bar beside the bell (TopBar.tsx, owner
 * 2026-10-21), where it covers nothing that takes focus. The guide has no top
 * bar, so there it is the card in the corner, as before.
 */
export function CatalogRebuildNotice({ compact = false }: { compact?: boolean }) {
  const rebuilding = useCatalogRebuild((s) => s.rebuilding);
  if (!rebuilding) return null;
  if (compact) {
    return (
      <div className="work-chip" role="status" aria-live="polite" title="Your new movies and series are being added. You can keep watching.">
        <Spinner />
        <span className="work-chip__text">
          <strong>Optimizing your app</strong>
        </span>
      </div>
    );
  }
  return (
    <div className="catalog-rebuild" role="status" aria-live="polite">
      <Spinner />
      <span className="catalog-rebuild__text">
        <strong>Optimizing your app</strong>
        <small>Your new movies and series are being added. You can keep watching.</small>
      </span>
    </div>
  );
}
